// APPLY: 0,
// CANCEL: 1,
// APPROVE: 2,
// REJECT: 3,

import receivedStatus from "./receivedStatus";
import withdrawStatus from "./withdrawStatus";

const withdrawStatusEnum = [
  {
    value: withdrawStatus.APPLY,
    label: "normal.status.pending",
    is_translation: true,
    key: "pending",
  },
  {
    value: withdrawStatus.CANCEL,
    label: "normal.cancel",
    is_translation: true,
    key: "cancel",
  },
  {
    value: withdrawStatus.APPROVE,
    label: "normal.status.success",
    is_translation: true,
    key: "success",
  },
  {
    value: withdrawStatus.REJECT,
    label: "normal.status.failed",
    is_translation: true,
    key: "failed",
  },
];

const receivedStatusEnum = [
  {
    value: receivedStatus.PENDING,
    label: "tradeRecord.receive.pending",
    is_translation: true,
    key: "pending",
  },
  {
    value: receivedStatus.RECEIVED,
    label: "tradeRecord.receive.received",
    is_translation: true,
    key: "received",
  },
  {
    value: receivedStatus.EXPIRED,
    label: "tradeRecord.receive.expired",
    is_translation: true,
    key: "expired",
  },
];

export { withdrawStatusEnum, receivedStatusEnum };
